exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".articlePageImageContainer\n{\n    height: 30vh;\n    position: relative;\n}\n\n.articlePageImageItem\n{\n    height: 30vh;\n    width: 24%;\n    background-size: cover;\n    background-position: center;\n/*    background-image: linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.9));*/\n    position: relative;\n    float: left;\n    margin-right: 1%;\n}\n\n#articlePageArticleImagesImage--1\n{\n    background-image: url(\"/assets/WilliamWylerThe1.jpg\");\n}\n\n#articlePageArticleImagesImage--2\n{\n    background-image: url(\"/assets/WilliamWylerThe2.jpg\");\n}\n\n#articlePageArticleImagesImage--3\n{\n    background-image: url(\"/assets/WilliamWylerThe3.jpg\");\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/imageSection/imageSection.component.css
// module id = ../../../../../src/app/components/imageSection/imageSection.component.css
// module chunks = main